export interface ITodo {
    id:number;
    title:string;
    description?:string;
    dueDate?:number;
    creator:number;
    completedBy?:number;
    completionTime?:number;
    hidden?:number[];
    seen?:number[];
    assigned?:number[];
    type:TODO_TYPE;
    visible:number[];
    renewal?:RENEWAL;
    handovergroup?:number;
    scheduleId?:number;
    // The child a packing item is for; null or missing for the whole family.
    tagged?:number|null;
}

export enum RENEWAL {
    PICKING_UP = "PICKING_UP",
    DROPPING_OFF = "DROPPING_OFF",
    STATIC = "STATIC",
    NONE = "NONE",
}

export enum TODO_TYPE {
    HANDOVER = "HANDOVER",
    NORMAL = "NORMAL",
}

// The server rejects todo titles outside these lengths.
export const TODO_TITLE_MIN_LENGTH = 3;
export const TODO_TITLE_MAX_LENGTH = 100;

export interface ICreateTodo {
    title:string;
    description?:string;
    dueDate?:number;
    assigned?:number[];
    visible:number[];
    type:TODO_TYPE;
    renewal?:RENEWAL;
    scheduleId?:number;
    tagged?:number|null;
}
export interface IEditTodo {
    id:number;
    title:string;
    description?:string;
    dueDate?:number;
    assigned?:number[];
    visible:number[];
    renewal?:RENEWAL;
    // Left out keeps the item's tag; null clears it.
    tagged?:number|null;
}

export interface ICompleteTodo {
    id:number;
    complete:boolean;
}

export interface IHideTodo {
    id:number;
}




// WEBPACK FOOTER //
// ./src/app-types/websocket/todo.types.ts